<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['class_mgt']">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <router-link
                :to="{ path: '/alevelsubjects' }"
                type="button"
                class="btn-sm btn btn-info mx-2"
              >
                <i class="mdi mdi-plus"></i> Add A'Level Subjects
              </router-link>
              <b-button v-b-modal.new-item size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i> New O'level Subject</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(class)="data">
                  {{ data.item.class.name }}
                </template>
                <template #cell(cores)="data">
                  {{ data.item.core }}
                </template>
                <template #cell(entrystatus)="data">
                  <span v-show="data.item.entrystatus == 1">O'level</span>
                  <span v-show="data.item.entrystatus == 2">A'level</span>
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="
                        edit(
                          data.item.id,
                          data.item.class.id,
                          data.item.name,
                          data.item.core,
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button
                      @click="remove(data.item.id, data.item.name)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-item"
        centered
        title="New Class Subject"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addItem">
          <div class="form-group mb-2">
            <label>Class</label>
            <multiselect
              v-model="schoolclass"
              label="name"
              :options="schoolclasses.filter((c) => c.level == 2)"
            ></multiselect>
            <label>Subject Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Core</label>
            <select class="form-control" v-model="core"
              ><option>Major</option
              ><option>Elective</option></select
            >
            <!-- <label>Education Level</label>
            <select class="form-control" v-model="entrystatus"><option>O Level</option><option>A Level</option></select> -->
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-item')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-item"
        centered
        title="Edit Class Subject"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editItem">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Class</label>
            <b-form-select
              v-model="schoolclass"
              required
              :options="schoolclasses.filter((c) => c.level == 2)"
              class="mb-3 form-control"
              value-field="id"
              text-field="name"
            ></b-form-select>
            <label>Subject Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Core</label>
            <select class="form-control" v-model="core"
              ><option>Major</option
              ><option>Elective</option></select
            >
            <!-- <label>Education Level</label>
            <select class="form-control" v-model="entrystatus"><option value="1">O'level</option><option value="2">A'level</option></select> -->
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-item')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-item"
        centered
        title="Delete Class Subject"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeItem">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Subject : <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-item')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schoolsubjectComputed,
  schoolsubjectMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Class Subjects",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Class Subjects",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Class Subjects", active: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "class", label: "Class", visible: true },
        { key: "name", label: "Subject", visible: true },
        { key: "cores", label: "Core", visible: true },
        { key: "entrystatus", label: "Status", visible: false },
        { key: "addedby", label: "Added by", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "",
      schoolclass: "",
      core: "",
      entrystatus: "",
    };
  },
  computed: {
    ...schoolsubjectComputed,
    ...schoolclassComputed,
    List() {
      return this.schoolsubjects.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.schoolsubjects.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.schoolsubjects.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchSchoolSubjects();
    this.fetchSchoolClasses();
    this.TotalRows = this.schoolsubjects.length;
    this.isBusy = false;
  },
  methods: {
    ...schoolsubjectMethods,
    ...schoolclassMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, schoolclass, name, core) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.name = name;
      this.core = core;
      //this.entrystatus=entrystatus;
      this.$bvModal.show("edit-item");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-item");
    },
    async addItem() {
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("class", this.schoolclass.id);
      formData.append("core", this.core);
      // formData.append("entrystatus",this.entrystatus);
      let url = "/addschoolsubject";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolSubjects();
          this.$bvModal.hide("new-item");
          this.name = "";
          this.class = "";
          this.core = "";
          // this.entrystatus="";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editItem() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("core", this.core);
      formData.append("class", this.schoolclass);
      // formData.append("entrystatus",this.entrystatus);
      let url = "/updateschoolsubject";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolSubjects();
          this.$bvModal.hide("edit-item");
          this.class = "";
          this.name = "";
          this.core = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeItem() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeschoolsubject";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSchoolSubjects();
          this.$bvModal.hide("delete-item");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
